export default __webpack_public_path__ + "static/media/artorias--back--240.0327042c.jpg";